import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import React, { useEffect, useState } from "react";
import { User } from "react-feather";
import { useLocation, useNavigate } from "react-router-dom";
import routes from "./../routes/index";

function Sidebar() {

    const location = useLocation();
    const navigate = useNavigate();

    const [routeList, setRouteList] = useState([]);

    useEffect(() => {
        let _routeList = [...routes];
        if(Array.isArray(_routeList)){
            _routeList = _routeList.map(route => {
                route.is_active = location.pathname.indexOf(route.path) === 0
                return route;
            })
        }
        setRouteList(_routeList);
    }, [location]);

    return <React.Fragment>
        {routeList.map((route, index) => (
            <ListItem button key={index} selected={route.is_active} onClick={() => { navigate(route.path) }}>
                <ListItemIcon>
                    {route.icon}
                </ListItemIcon>
                <ListItemText primary={route.id} />
            </ListItem>
        ))}
    </React.Fragment>
}

export default Sidebar;